import { takeEvery, select, call, put } from 'redux-saga/effects';
import { fetchImages } from '../api';
import { IMAGES } from '../constants';
import { setImages, setError } from '../actions';

export const getPage = state => state.nextPage;

export function* handleImagesLoad() {
    try {
        const page = yield select(getPage);
        const images = yield call(fetchImages, page);
        yield put(setImages(images));
    } catch (error) {
        yield put(setError(error.toString()));
    }
}

export default function* watchImageLoad() {
    yield takeEvery(IMAGES.LOAD, handleImagesLoad);
}
